<app-header></app-header>

<div class="politique-confidentialite-page">
  <div class="container">
    <!-- En-tête -->
    <div class="header-section">
      <h1 class="main-title">Politique de Confidentialité</h1>
      <p class="subtitle">Cette politique s'applique au site pdf-to-word.fr</p>
      <p class="date-update">Date de dernière mise à jour : 04 août 2025</p>
    </div>

    <!-- Introduction -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">Introduction</h2>
        <div class="content-text">
          <p>Le respect de votre vie privée est de la plus haute importance pour SBDI, responsable de ce site.</p>
          <p>Cette politique de confidentialité vise à vous expliquer :</p>
          <ul class="policy-list">
            <li>Comment vos renseignements personnels et fichiers sont collectés et traités</li>
            <li>Vos droits relatifs à ces données</li>
            <li>Qui est responsable du traitement</li>
            <li>À qui ces données peuvent être transmises</li>
            <li>La politique du site en matière de fichiers témoins ("cookies")</li>
          </ul>
          <p>Cette politique complète nos Conditions générales d'utilisation disponibles à l'adresse suivante :</p>
          <div class="action-link">
            <a href="/conditions-generales-ventes" class="btn-primary" target="_blank">Consulter les CGU</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Collecte de données -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">1. Collecte de Renseignements Personnels et Techniques</h2>
        <div class="content-text">
          <p>Nous collectons les renseignements suivants lorsque vous utilisez notre outil de conversion PDF vers Word :</p>
          <ul class="policy-list">
            <li>Adresse électronique (si fournie pour assistance ou retour de document)</li>
            <li>Adresse IP</li>
            <li>Données techniques relatives aux fichiers soumis (nom de fichier, format, poids, métadonnées)</li>
            <li>Informations de navigation (type de navigateur, système d'exploitation, temps de traitement)</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Méthodes de collecte -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">2. Méthodes de Collecte</h2>
        <div class="content-text">
          <p>Les données sont collectées via :</p>
          <ul class="policy-list">
            <li>L'utilisation de notre outil de conversion</li>
            <li>Les échanges par courriel via notre formulaire de contact (le cas échéant)</li>
          </ul>
          <p><strong>Finalités des données collectées :</strong></p>
          <ul class="policy-list">
            <li>Exécuter la conversion de vos fichiers PDF en documents Word</li>
            <li>Améliorer la qualité et la performance du service</li>
            <li>Répondre à vos demandes de support technique</li>
            <li>Assurer la sécurité du site</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Interactivité -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">3. Interactivité</h2>
        <div class="content-text">
          <p>Une interactivité peut s'établir entre vous et notre site par le biais de messages de support ou de demandes d'assistance. Ces échanges peuvent contenir :</p>
          <ul class="policy-list">
            <li>Adresse email</li>
            <li>Informations techniques sur le fichier concerné</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Cookies -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">4. Fichiers Journaux et Témoins (Cookies)</h2>
        <div class="content-text">
          <p>Nous utilisons des cookies et des fichiers journaux pour améliorer votre expérience :</p>
          
          <h3 class="subsection-title">a) Informations collectées :</h3>
          <ul class="policy-list">
            <li>Adresse IP</li>
            <li>Type de navigateur et système d'exploitation</li>
            <li>Pages visitées</li>
            <li>Date et heure d'accès</li>
            <li>Fichier(s) soumis pour conversion</li>
          </ul>
          
          <h3 class="subsection-title">b) Finalités :</h3>
          <ul class="policy-list">
            <li>Fonctionnement optimal du service</li>
            <li>Mesure de la performance</li>
            <li>Statistiques anonymes d'utilisation</li>
          </ul>
          
          <h3 class="subsection-title">c) Opposition aux cookies :</h3>
          <p>Vous pouvez désactiver les cookies via les paramètres de votre navigateur. Cela n'empêchera pas l'utilisation du service.</p>
        </div>
      </div>
    </div>

    <!-- Partage des données -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">5. Partage des Renseignements Personnels et Fichiers</h2>
        <div class="content-text">
          <p>Nous ne vendons ni ne commercialisons vos données personnelles. Les fichiers que vous téléversez sont traités automatiquement, non consultés manuellement, et supprimés automatiquement dans un délai défini selon votre plan d'utilisation.</p>
        </div>
      </div>
    </div>

    <!-- Durée de conservation -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">6. Durée de Conservation des Fichiers et Renseignements Personnels</h2>
        <div class="content-text">
          <p>Les fichiers PDF soumis et les documents convertis sont stockés temporairement sur nos serveurs sécurisés.</p>
          <p>La durée de conservation peut varier en fonction du plan sélectionné au moment de l'utilisation du service. Une fois cette durée écoulée, les fichiers sont automatiquement et définitivement supprimés de nos systèmes.</p>
          <p>Vous avez également la possibilité de demander la suppression anticipée de vos fichiers à tout moment, via le lien suivant :</p>
          <div class="action-link">
            <a href="https://www.pdf-to-word.fr/supprimer-mes-donnees-personnelles" class="btn-primary" target="_blank">Supprimer mes données</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Hébergement -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">7. Hébergement</h2>
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Notre site est hébergé par :</span>
            <span class="info-value">Agence des media Numériques (AMEN)</span>
          </div>
          <div class="info-item">
            <span class="info-label">Adresse :</span>
            <span class="info-value">12 à 14 Chez Regus, 12 rond point des Champs Elysées M. Dassault 75008 Paris</span>
          </div>
          <div class="info-item">
            <span class="info-label">Téléphone :</span>
            <span class="info-value">01 70 99 53 41</span>
          </div>
          <div class="info-item">
            <span class="info-label">Horaires :</span>
            <span class="info-value">Du lundi au vendredi 9h - 18h</span>
          </div>
        </div>
        <div class="content-text">
          <p>Les fichiers et données sont hébergés sur des serveurs sécurisés situés au Canada, dans le respect des normes de protection des données.</p>
        </div>
      </div>
    </div>

    <!-- Responsable du traitement -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">8. Responsable du Traitement</h2>
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Le responsable du traitement est :</span>
            <span class="info-value">David Zacchara</span>
          </div>
          <div class="info-item">
            <span class="info-label">Contact :</span>
            <span class="info-value">{{ supportEmail }}</span>
          </div>
        </div>
        <div class="content-text">
          <p>Il veille à la sécurité, à la confidentialité, et à la conformité du traitement des données collectées.</p>
        </div>
      </div>
    </div>

    <!-- Droits d'opposition -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">9. Droits d'Opposition et de Retrait</h2>
        <div class="content-text">
          <p>Vous pouvez à tout moment :</p>
          <ul class="policy-list">
            <li>Refuser que vos données personnelles soient conservées</li>
            <li>Demander leur suppression</li>
          </ul>
          <p><strong>Procédure :</strong></p>
          <p>Envoyez un courriel à : {{ supportEmail }}</p>
          <p>ou utilisez le lien suivant :</p>
          <div class="action-link">
            <a href="https://www.pdf-to-word.fr/supprimer-mes-donnees-personnelles" class="btn-primary" target="_blank">Supprimer mes données</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Droit d'accès -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">10. Droit d'Accès, de Rectification et de Suppression</h2>
        <div class="content-text">
          <p>Vous pouvez consulter, modifier ou supprimer vos données en suivant la même procédure que ci-dessus.</p>
        </div>
      </div>
    </div>

    <!-- Sécurité -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">11. Sécurité</h2>
        <div class="content-text">
          <p>Nous mettons en place les mesures suivantes pour protéger vos fichiers et données :</p>
          <ul class="policy-list">
            <li>Chiffrement SSL (Secure Sockets Layer)</li>
            <li>Stockage temporaire sécurisé</li>
            <li>Pare-feu et surveillance du réseau</li>
            <li>Suppression automatique des fichiers</li>
            <li>Aucun accès manuel aux documents</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Délégué à la protection -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">12. Délégué à la Protection des Données</h2>
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Nom :</span>
            <span class="info-value">David Zacchara</span>
          </div>
          <div class="info-item">
            <span class="info-label">Courriel :</span>
            <span class="info-value">{{ supportEmail }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Utilisation par des mineurs -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">13. Utilisation par des Mineurs</h2>
        <div class="content-text">
          <p>Notre service n'est pas destiné aux mineurs de moins de 15 ans sans le consentement d'un représentant légal.</p>
        </div>
      </div>
    </div>

    <!-- Modification de la politique -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">14. Modification de la Politique</h2>
        <div class="content-text">
          <p>La présente politique est disponible à tout moment à :</p>
          <div class="action-link">
            <a href="/politique-de-confidentialite" class="btn-primary">Politique de confidentialité</a>
          </div>
          <p class="mt-4">Elle peut être modifiée pour rester conforme à la législation. En cas de changement important, vous serez notifié(e) par courriel (si vous nous l'avez communiqué).</p>
        </div>
      </div>
    </div>

    <!-- Acceptation -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">15. Acceptation</h2>
        <div class="content-text">
          <p>En utilisant notre service, vous acceptez cette politique de confidentialité, notamment concernant :</p>
          <ul class="policy-list">
            <li>La collecte de données techniques nécessaires à la conversion</li>
            <li>Le traitement temporaire de vos fichiers PDF</li>
            <li>L'utilisation de cookies techniques</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Législation applicable -->
    <div class="info-section">
      <div class="info-card">
        <h2 class="section-title">16. Législation Applicable</h2>
        <div class="content-text">
          <p>Nous respectons :</p>
          <ul class="policy-list">
            <li>Le Règlement général sur la protection des données (RGPD – UE 2016/679)</li>
            <li>La Loi sur la protection des renseignements personnels dans le secteur privé (RLRQ c P-39.1)</li>
            <li>La Loi canadienne sur la protection des renseignements personnels et les documents électroniques (LC 2000, c 5)</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
